import { render, staticRenderFns } from "./SharePanel.vue?vue&type=template&id=321a3920"
import script from "./SharePanel.vue?vue&type=script&lang=ts"
export * from "./SharePanel.vue?vue&type=script&lang=ts"
import style0 from "./SharePanel.vue?vue&type=style&index=0&id=321a3920&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports